<!-- FORM FIELDS -->
<p-panel>
  <ng-container *ngIf="isReactiveFormReady; else reactiveFormLoadingState">
    <div class="row">
      <div class="col">
        <app-reactive-form-support-data-readiness
          [items]="fitosanitariosSupportDataReadinessItems"
          [severity]="fitosanitariosSupportDataReadinessSeverity"
          [summary]="fitosanitariosSupportDataReadinessSummary"
          [title]="fitosanitariosSupportDataReadinessTitle"
          [visible]="isReactiveFormReady"
        >
        </app-reactive-form-support-data-readiness>

        <app-reactive-form-builder
          (afterSend)="onAfterSend($event)"
          (goBack)="goBack()"
          (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
          (lazyDropdownRequested)="onReactiveLazyDropdownRequested($event)"
          (lazyDropdownFilterRequested)="onReactiveLazyDropdownFilterRequested($event)"
          (stableValueChanges)="stableValueChanges($event)"
          [debug]="debugFitosanitariosForm"
          [form]="form.formFields"
          [getRequest]="getRequest"
          [id]="reactiveFormRecordId"
          [previousData]="initialPreviousData"
          [request]="request"
          [serverUrl]="env.auxServerUrl"
          [undoEnabled]="undoEnabled"
        >
        </app-reactive-form-builder>
      </div>
    </div>
  </ng-container>
</p-panel>

<ng-template #reactiveFormLoadingState>
  <div class="p-3 text-center" role="status" aria-live="polite">
    <div *ngIf="!reactiveFormLoadingError" class="text-muted">
      {{ reactiveFormLoadingLabel }}
    </div>
    <div *ngIf="reactiveFormLoadingError" class="alert alert-danger mb-0" role="alert">
      {{ reactiveFormLoadingError }}
    </div>
  </div>
</ng-template>

<p-dialog *ngIf="form" [visible]="form.showDialogTratamiento()" (onHide)="productsTratamientos = []" (onShow)="getDataProducts()" [modal]="true" [style]="{width: '80vw'}" [closable]="false" (onHide)="form.showDialogTratamiento.set(false)">
    <ng-template pTemplate="header">
        <div class="d-flex justify-content-left align-content-center">
            <div>
                <h4>Productos fitosanitarios</h4>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <table class="table table-striped">
            <thead>
                <tr class="table-dark">
                    <th></th>
                    <th>Producto</th>
                    <th>Uso</th>
                    <th>Agente</th>
                    <th>Dosis Min.</th>
                    <th>Dosis Max.</th>
                    <th>Vol. Caldo</th>
                    <th>N° Máx. Aplicaciones</th>
                    <th>Composición</th>
                    <th>Condiciones de uso</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let producto of productsTratamientos; let i = index">
                    <td style="width: 40px; text-align: center;">
                        {{i + 1}}
                    </td>
                    <td>{{producto.nombre_comercial}}</td>
                    <td>{{producto.uso}}</td>
                    <td>{{producto.dosis_min}} {{producto.unidades}}</td>
                    <td>{{producto.dosis_max}} {{producto.unidades}}</td>
                    <td>
                        {{producto.vol_caldo_min ?? 'N/A'}} -
                        {{producto.vol_caldo_max ?? 'N/A'}}
                    </td>
                    <td>{{producto.n_aplicaciones}}</td>
                    <td>{{producto.composicion}}</td>
                    <td>{{producto.condiciones_uso}}</td>
                </tr>
            </tbody>
        </table>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton severity="primary" type="button" label="Cerrar" icon="pi pi-times" (click)="form.showDialogTratamiento.set(false)"></button>
    </ng-template>
</p-dialog>
